// extracted by mini-css-extract-plugin
module.exports = {"spotlight":"spotlight-module--spotlight--jSXuV","spotlight__icon":"spotlight-module--spotlight__icon--1f_kz"};